import { createContext } from 'react'

// Separado de SesionProvider.jsx y useSesion.js a propósito: un archivo que
// mezcla un componente con otros exports (el hook) rompe el fast refresh.
export const ContextoSesion = createContext(null)
